var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.917,
    height: 23.917,
    viewBox: "0 0 23.917 23.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:6px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    transform: "translate(-43.541 -589.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    d: "M55.5 596.249v17.917",
    className: "cls-1",
    transform: "translate(0 -4.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    d: "M55.5 596.249v17.917",
    className: "cls-1",
    transform: "rotate(90 57.548 603.16)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButton);
export default __webpack_public_path__ + "static/media/plus-button.f9a0be6a4fc66cf5a41bad4d04c60afd.svg";
export { ForwardRef as ReactComponent };